"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combinationsDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var combinationsDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createCombinations: _factoriesAny.createCombinations
};
exports.combinationsDependencies = combinationsDependencies;